import {
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../../Api/FetchHooks";
import { useLocation } from "react-router-dom";
import {
  formatCurrencyV2,
  formatDate,
  getUserDetails,
} from "../../../utils/helpers";
import TransactionTable from "../../../Components/TransactionTable";
import AlertComponent from "../../../Components/AlertComponent";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import UseServerTable from "../../../Hooks/UseServerTable";
import Page from "../../../Components/Page";

const UserOutstandingDisbursements = ({ _user, showHeader = true }) => {
  const location = useLocation();
  const LoggedInUser = getUserDetails();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [user, setUser] = useState(_user || LoggedInUser);
  const [status, setStatus] = useState("active");
  const [transactions, setTransactions] = useState([]);

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchTransactions = useCallback(async () => {
  //   await request({
  //     url: `/transaction?filter_value=${user?.id}&type=in_wallet&status=${status}`,
  //   });
  // }, [user?.id, status]);

  // useEffect(() => {
  //   fetchTransactions();
  // }, [fetchTransactions]);

  // useEffect(() => {
  //   if (response?.data?.Data) setTransactions(response.data.Data);
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/outstanding_disbursement?entity_id="${user?.id}"`,
    onSuccess: (data) => {
      setTransactions(data.Report);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "last_updated_on",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "reference",
      headerName: "Reference",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Transaction ID",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "msisdn",
      headerName: "Destination",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
      valueGetter: (params) =>
        parseInt(params?.row?.amount) + parseInt(params?.row?.b2c_charge),
    },
    {
      field: "disburse",
      headerName: "Disbursed Amount",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
      renderCell: (params) => {
        return (
          <Chip
            label={
              params?.value === 1
                ? "pending"
                : params?.value === 2
                  ? "processed"
                  : "pending"
            }
            color={
              params?.value === 1
                ? "secondary"
                : params?.value === 2
                  ? "info"
                  : "secondary"
            }
          />
        );
      },
    },
  ];

  return (
    <Page title={"Outstanding Disbursements"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />
      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">Outstanding Disbursements</Typography>
              )}
            </>
          }
          // action={
          //   <Box display={"flex"}>
          //     <FormControl
          //       sx={{
          //         width: "20vw",
          //         mr: "20px",
          //       }}
          //     >
          //       <InputLabel id="status" size="small">
          //         Status
          //       </InputLabel>

          //       <Select
          //         labelId="loan_status"
          //         id="loan_status"
          //         value={status}
          //         label="status"
          //         onChange={(e) => {
          //           setStatus(e.target.value);
          //         }}
          //         size="small"
          //         defaultValue="active"
          //       >
          //         <MenuItem value="active">Active</MenuItem>
          //         <MenuItem value="inactive">Inactive</MenuItem>
          //         <MenuItem value="domant">Dormant</MenuItem>
          //         <MenuItem value="suspended">Suspended</MenuItem>
          //         <MenuItem value="closed">Closed</MenuItem>
          //         <MenuItem value="pending">Pending</MenuItem>
          //         <MenuItem value="cancelled">Cancelled</MenuItem>
          //       </Select>
          //     </FormControl>
          //   </Box>
          // }
        />
        <CardContent>
          {transactions && transactions.length > 0 ? (
            <>
              <TransactionTable
                data={transactions}
                columns={columns}
                {...gridProps}
              />
            </>
          ) : gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid
              container
              display={"flex"}
              direction={"column"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AllInboxIcon color="error" sx={{ mx: "auto", fontSize: 80 }} />
              <Typography>No recent transactions</Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default UserOutstandingDisbursements;
